<script setup>
import CourseItem from '@/components/home/CourseItem.vue'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import ClLoading from '@/components/base/ClLoading.vue'
const isLoading = ref(false)
import { onMounted, ref } from 'vue'

const CategoryBannerRepo = RepositoryFactory.get('CategoryBanner')
const categoryBanners = ref('')
onMounted(async () => {
  isLoading.value = true
  try {
    const { data } = await CategoryBannerRepo.get()
    categoryBanners.value = data
    isLoading.value = false
  } catch (error) {
    isLoading.value = false
    console.log('FETCH COURSE IMAGE BANNERS ERROR:',error)

  }
})

</script>

<template>
  <v-container  class="cl__section__margin__bottom position-relative">
    <v-row class="mb-8">
      <v-col cols="12" class="d-flex flex-column justify-center align-center text-center ">
        <h1 class="font-weight-bold cl-section__title" :class="[!$vuetify.display.mdAndDown ? 'mb-10' : '']" style="color: rgba(104, 109, 122, 1)">
          <span class="text-dark">کلاس‌های آنلاین</span> کلاسینو رو بیشتر بشناس!
        </h1>
        <p class="cl__section__subtitle">
          می‌خوای برای آزمون تیزهوشان آماده بشی؟ نگران امتحانات نهایی هستی؟ یا شاید می‌خوای دست‌پر بری سر جلسه کنکور سراسری! کافیه هدفت رو بهمون بگی تا کلاسینو با بهترین برنامه همراهیت کنه.
        </p>
      </v-col>
    </v-row>
    <ClLoading v-if="isLoading" v-model="isLoading"/>
    <div v-else>
      <CourseItem v-if='categoryBanners.length > 0' :items="categoryBanners"></CourseItem>
      <v-row>
        <v-col cols="12" class="d-flex justify-center">
          <v-btn
            size="large"
            color="#155EEF"
            class="rounded-lg mb-4 text-decoration-none  font-weight-bold"
            style="letter-spacing: 0"
            :to="{name:'courses'}"
            :width="$vuetify.display.mdAndDown?'90%':''"
          >
            مشاهده همه دوره‌ها
            <v-icon icon="$mdiChevronLeftBoxOutline" class="mx-2"></v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>


<style scoped>

</style>
